import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes.js";
import { AuthProvider } from "./lib/AuthContext.js";
import { installTooltipEdges } from "./lib/tooltipEdges.js";
// Plus Jakarta Sans is bundled and served from our own origin — no Google Fonts request, so no
// candidate or recruiter IP goes to a third party just to render text (FOUNDER_PACK §3/§6).
import "@fontsource-variable/plus-jakarta-sans";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/t1-dashboard.css";
import "./styles/t1-requirement.css";
import "./styles/t1-interviews.css";
import "./styles/t1-candidates.css";
import "./styles/t1-candidate-flow.css";
import "./styles/t1-settings.css";
import "./styles/t1-admin.css";
import "./styles/t1-activity.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

installTooltipEdges();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
